import { Store } from '@sama/app-state';
import { filter, omit } from '@sama/micro-dash';
import { ShapeGroupOrderState } from '../../../../../team-apis/content/content-connector';
import {
  PointType,
  ShapeType,
} from '../../../../../team-apis/otterdam/answers/shape-typings';
import {
  ShapeGroupState,
  ShapeOrGroupOrderItem,
} from '../../../../state/shape-group-state';
import { ObjectWith } from '../../../../types/misc';
import { removeShapesFromGroups } from '../shape-group-state';
import { getShapeForEventTracking, ShapeState } from '../shape-state';

export function deleteShapes(
  indexesToDelete: number[],
  shapeGroupOrderStore: Store<ShapeGroupOrderState>,
) {
  const shapeGroupOrder = shapeGroupOrderStore.state();
  shapeGroupOrderStore.getRootStore().batch(() => {
    const { shapes, groups, shapeAndGroupOrder } =
      getUpdatedShapeGroupOrderAfterDeleteShapes(
        shapeGroupOrder,
        indexesToDelete,
      );
    shapeGroupOrderStore('shapes').set(shapes);
    // @ts-ignore -- fix me
    shapeGroupOrderStore('groups').set(groups);
    shapeGroupOrderStore('shapeAndGroupOrder').set(shapeAndGroupOrder);
  });
}

export function getUpdatedShapeGroupOrderAfterDeleteShapes<
  P extends PointType,
  T extends ShapeType,
  S extends ShapeState<P, T>,
>(shapeGroupOrder: ShapeGroupOrderState<T, P, S>, indexesToDelete: number[]) {
  const updatedShapes = removeShapesFromShapes(
    indexesToDelete,
    shapeGroupOrder.shapes,
  );
  const updateGroups = removeShapesFromGroups(
    shapeGroupOrder.groups,
    indexesToDelete,
  );
  const updatedOrder = filterShapesAndGroupsFromOrder(
    // @ts-ignore -- fix me
    updateGroups,
    updatedShapes,
    shapeGroupOrder.shapeAndGroupOrder,
  );
  return {
    shapes: updatedShapes,
    groups: updateGroups,
    shapeAndGroupOrder: updatedOrder,
  };
}

export function removeShapesFromShapes<
  P extends PointType,
  T extends ShapeType,
  S extends ShapeState<P, T>,
>(indexesToRemove: number[], shapes: StrictRecord<ShapeState['index'], S>) {
  return omit(shapes, ...indexesToRemove);
}

export function filterShapesAndGroupsFromOrder(
  groups: ObjectWith<ShapeGroupState>,
  shapes: ObjectWith<ShapeState>,
  shapeAndGroupOrder: ShapeOrGroupOrderItem[],
) {
  // fix me if you change this code
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
  return shapeAndGroupOrder.filter((item) => {
    if (item.type === 'shape') {
      return shapes[item.index];
    } else {
      return groups[item.index];
    }
  });
}

export function getShapesForEventTracking<
  P extends PointType,
  S extends ShapeType,
>(shapes: ObjectWith<ShapeState<P, S>>, shapeIndexes: number[]) {
  return filter(shapes, (shape) => shapeIndexes.includes(shape.index)).map(
    getShapeForEventTracking,
  );
}
